module.exports = __webpack_public_path__ + "static/tablet-c1550eeda148a078ffae03ea95fdd2fd.png";